module.exports = __webpack_public_path__ + "static/media/logoutLogo.c7a682e4.svg";